import { render, staticRenderFns } from "./Likes.vue?vue&type=template&id=b8665d4e&scoped=true&"
import script from "./Likes.vue?vue&type=script&lang=js&"
export * from "./Likes.vue?vue&type=script&lang=js&"
import style0 from "./Likes.vue?vue&type=style&index=0&id=b8665d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8665d4e",
  null
  
)

export default component.exports